import { connectRefinementList } from "instantsearch.js/es/connectors"
import {
  RefinementListConnector,
  RefinementListConnectorParams,
  RefinementListWidgetDescription,
} from "instantsearch.js/es/connectors/refinement-list/connectRefinementList"
import { noop } from "instantsearch.js/es/lib/utils"
import {
  AdditionalWidgetProperties,
  useConnector,
  UseRefinementListProps,
} from "react-instantsearch-core"

export function useRefinementList(
  props: UseRefinementListProps,
  additionalWidgetProperties?: AdditionalWidgetProperties
) {
  const connectNoCleanUpRefinementList: RefinementListConnector = (
    renderFn,
    unmountFn = noop
  ) => {
    const connector = connectRefinementList(renderFn, unmountFn)

    return (widgetParams) => {
      const newInstance = connector(widgetParams)

      newInstance.dispose = () => {
        unmountFn()
      }

      return newInstance
    }
  }

  return useConnector<
    RefinementListConnectorParams,
    RefinementListWidgetDescription
  >(connectNoCleanUpRefinementList, props, additionalWidgetProperties)
}
